import React, { useEffect, useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { toast } from 'react-toastify';
import { Create_Api, Create_Api_Formdata } from '../../API_URL';

const AccContact = () => {

    const [FirstName, setFirstName] = useState('');
    const [EnquiryType, setEnquiryType] = useState('OtherEnquiry');
    const [Email, setEmail] = useState('');
    const [Number, setNumber] = useState('');
    const [Company, setCompany] = useState('');
    const [Enquiry, setEnquiry] = useState('');
    const [Message, setMessage] = useState('');
    const [IsLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState("");
    const [Image, setImage] = useState(null);



    const [num1, setNum1] = useState(0);
    const [num2, setNum2] = useState(0);
    const [captchaValue, setCaptchaValue] = useState("");
    const [captchaError, setCaptchaError] = useState("");


    const generateCaptcha = () => {
        const a = Math.floor(Math.random() * 9) + 1;
        const b = Math.floor(Math.random() * 9) + 1;
        setNum1(a);
        setNum2(b);
        setCaptchaValue("");
        setCaptchaError("");
    };

    useEffect(() => {
        generateCaptcha();
    }, []);

    const CreateContactUs = async () => {

        if (parseInt(captchaValue) !== num1 + num2) {
            setCaptchaError("Captcha is incorrect");
            return;
        }

        setCaptchaError("");

        let newErrors = {};

        if (!FirstName.trim()) newErrors.FirstName = "Full Name is required";
        if (!Email.trim()) {
            newErrors.Email = "Email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(Email)) {
            newErrors.Email = "Please enter a valid email address";
        }

        if (!Number.trim()) {
            newErrors.Number = "Phone number is required";
        } else if (!/^\d{10}$/.test(Number)) {
            newErrors.Number = "Please enter a valid 10-digit phone number";
        }

        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) return;

        const formData = new FormData();

        formData.append("FirstName", FirstName);
        formData.append("Email", Email);
        formData.append("PhoneNumber", Number);
        formData.append("Company", Company);
        formData.append("Enquiry", Enquiry);
        formData.append("EnquiryType", EnquiryType);
        formData.append("Message", Message);

        if (Image) {
            formData.append("Image", Image);
        }

        try {
            setIsLoading(true);
            const response = await Create_Api_Formdata("api/admin/CreateContactus", formData);
            if (response?.data) {
                // toast.success("Your message has been received. We’ll get back to you as soon as possible.");
                setSuccessMessage(
                    "Your message has been received. We’ll get back to you as soon as possible."
                );
                setFirstName("");
                setEmail("");
                setNumber("");
                setCompany("");
                setEnquiry("");
                setMessage("");
                generateCaptcha();
            } else {
                toast.error(response?.message || "Failed to upload requirement");
            }
        } catch (error) {
            console.error("Error uploading requirement:", error);
            toast.error(error?.response?.message || "Failed to upload requirement");
        } finally {
            setIsLoading(false);
        }
    };



    // Common styles for consistent look across all inputs
    const inputStyles = "w-full bg-transparent border-0 border-b border-gray-300 py-3 text-gray-700 placeholder:text-gray-400 focus:ring-0 focus:border-[#ED6800] outline-none transition-colors shadow-none rounded-none font-graphik";

    return (
        <div className="w-full lg:w-full max-w-[836px] bg-white shadow-[0_20px_60px_rgba(0,0,0,0.08)] p-8 lg:p-12 border border-gray-50">
            <div className="flex gap-4 mb-12">
                <button
                    type="button"
                    onClick={() => setEnquiryType("BussinessEnquiry")}
                    className={`px-6 py-3 border font-medium transition-all duration-300 ${EnquiryType === "BussinessEnquiry"
                        ? "bg-[#ED6800] text-white border-[#ED6800]"
                        : "bg-white text-[#01386A] border-[#BAC9D7] hover:border-[#ED6800]"
                        }`}
                >
                    Business Enquiry
                </button>

                <button
                    type="button"
                    onClick={() => setEnquiryType("OtherEnquiry")}
                    className={`px-6 py-3 border font-medium transition-all duration-300 ${EnquiryType === "OtherEnquiry"
                        ? "bg-[#ED6800] text-white border-[#ED6800]"
                        : "bg-white text-[#01386A] border-[#BAC9D7] hover:border-[#ED6800]"
                        }`}
                >
                    Other Enquiry
                </button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-[24px]">

                <div className="group">
                    <input
                        type="text"
                        placeholder="Full Name *"
                        className={inputStyles}
                        value={FirstName}
                        onChange={(e) => setFirstName(e.target.value)}
                    />
                    {errors?.FirstName && (
                        <span className="text-red-500 text-sm">{errors?.FirstName}</span>
                    )}
                </div>
                {/* Email */}
                <div className="group">
                    <input
                        type="email"
                        placeholder="Email *"
                        className={inputStyles}
                        value={Email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    {errors?.Email && (
                        <span className="text-red-500 text-sm">{errors?.Email}</span>
                    )}
                </div>

                {/* Phone */}
                <div className="group">
                    <input
                        type="tel"
                        placeholder="Phone *"
                        className={inputStyles}
                        value={Number}
                        onChange={(e) => setNumber(e.target.value)}
                    />
                    {errors?.Number && (
                        <span className="text-red-500 text-sm">{errors?.Number}</span>
                    )}
                </div>
                <div className="group">
                    <input
                        type="text"
                        placeholder="Company *"
                        className={inputStyles}
                        value={Company}
                        onChange={(e) => setCompany(e.target.value)}
                    />
                </div>

                {/* Enquiry Type */}
                <div className="group">
                    <select
                        className={`${inputStyles} bg-white`}
                        value={Enquiry}
                        onChange={(e) => setEnquiry(e.target.value)}
                    >
                        <option value="" disabled selected>Select Enquiry Type *</option>
                        <option value="service">Service Request</option>
                        <option value="job">Job Application</option>
                        <option value="partnership">Partnership</option>
                        <option value="product">Product</option>
                        <option value="other">Other</option>
                    </select>
                </div>

                {/* Message */}
                <div className="md:col-span-2 group">
                    <input
                        type="text"
                        placeholder="Your Message *"
                        className={inputStyles}
                        value={Message}
                        onChange={(e) => setMessage(e.target.value)}
                    />
                </div>
                {EnquiryType === "BussinessEnquiry" && (
                    <div className="relative z-0 w-full md:col-span-2 group">
                        <label
                            htmlFor="document"
                            className="text-[14px] text-[#01386A] font-outfit font-[400]"
                        >
                            Upload Document <span className="text-orange-500">*</span>
                        </label>

                        <input
                            type="file"
                            id="document"
                            accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
                            className={`${inputStyles} py-2 file:mr-4 file:px-4 file:py-2 file:border-0 file:bg-[#ED6800] file:text-white file:cursor-pointer`}
                            onChange={(e) => setImage(e.target.files[0])}
                        />

                        {Image && (
                            <p className="mt-2 text-sm text-green-600">
                                Selected: {Image.name}
                            </p>
                        )}
                    </div>
                )}
                <div className="grid gap-[6px] col-span-1 lg:col-span-2 mt-[15px]">

                    <label className="text-[#242424] text-[16px]">
                        Captcha <span className="text-red-500">*</span>
                    </label>

                    <div className="flex items-center gap-[15px]">
                        <div className="text-black text-[18px] font-[600]">
                            {num1} + {num2} =
                        </div>

                        <input
                            type="text"
                            value={captchaValue}
                            onChange={(e) => setCaptchaValue(e.target.value)}
                            className="
                                                bg-transparent px-0
                                                border-0 border-b
                                                border-black
                                                text-black
                                                focus:border-black
                                                lg:py-[8px] w-[120px]
                                                outline-none focus:outline-none focus:ring-0
                                            "
                        />

                        <button
                            type="button"
                            onClick={generateCaptcha}
                            className="text-[#ED6800] text-[14px] underline"
                        >
                            Refresh
                        </button>
                    </div>

                    {captchaError && (
                        <span className="text-red-500 text-sm">{captchaError}</span>
                    )}
                </div>
                <div className="md:col-span-2 mt-4">

                    {successMessage && (
                        <div className="mb-4 p-4 bg-green-50 border border-green-300 text-green-700 rounded-md">
                            {successMessage}
                        </div>
                    )}

                    <button
                        onClick={CreateContactUs}
                        className="flex items-center gap-2 px-8 py-3 border border-[#ED6800] text-[#ED6800] font-[600] text-lg hover:bg-[#ED6800] hover:text-white transition-all duration-300 group"
                    >
                        {IsLoading ? "Please Wait" : "Submit"}
                        <ArrowRight size={20} className="transition-transform duration-300 group-hover:translate-x-1" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AccContact;